module.exports = __webpack_public_path__ + "static/LaDaDi_Logo_mC_unten_RGB_L_fin-50d982b0cd0f7e53456d27db9b77f4d1.jpg";